module.exports = __webpack_public_path__ + "img/grand-osasis-cancun-pool.1beb405e.jpg";